import { addDays, format } from 'date-fns';
import type { Deal } from '@elka/types';
import { localDateStr } from '../../../lib/relativeTime';

export const WAIT_OPTIONS = [
  { days: 7, label: 'שבוע' },
  { days: 14, label: 'שבועיים' },
  { days: 30, label: 'חודש' },
] as const;

export const DEFAULT_WAIT_REASON = 'הכדור אצל הלקוח';

/** Parses 'yyyy-MM-dd' as a local date. */
const parseLocal = (s: string) => new Date(`${s}T00:00:00`);

export function isDealWaiting(
  deal: Pick<Deal, 'waitingUntil'>,
  today: string = localDateStr()
): boolean {
  return !!deal.waitingUntil && deal.waitingUntil > today;
}

/** Firestore patch to start (days) or clear (null) a wait. '' clears — updateDoc rejects undefined. */
export function waitPatch(
  days: number | null,
  deal?: Pick<Deal, 'waitingReason'>,
  today: string = localDateStr()
): { waitingUntil: string; waitingReason: string } {
  if (days === null) return { waitingUntil: '', waitingReason: '' };
  return {
    waitingUntil: format(addDays(parseLocal(today), days), 'yyyy-MM-dd'),
    waitingReason: deal?.waitingReason || DEFAULT_WAIT_REASON,
  };
}

/** The option to highlight for the current wait, or null when not waiting. */
export function selectedWaitDays(
  deal: Pick<Deal, 'waitingUntil'>,
  today: string = localDateStr()
): number | null {
  if (!isDealWaiting(deal, today)) return null;
  const remaining = Math.round(
    (parseLocal(deal.waitingUntil!).getTime() - parseLocal(today).getTime()) / 86_400_000
  );
  // ponytail: approximation — we don't store which option was picked, so pick the first one that still covers the remaining days.
  return (WAIT_OPTIONS.find((o) => o.days >= remaining) ?? WAIT_OPTIONS[WAIT_OPTIONS.length - 1])
    .days;
}
